import { ref } from 'vue'

/**
 * Composable for managing prompts
 * @returns {Object} Prompt management state and methods
 */
export function usePromptManagement() {
  // State
  const showPromptModal = ref(false)
  const selectedCategory = ref(null)
  const isLoading = ref(false)

  /**
   * Opens the prompt modal
   */
  const openPromptModal = () => {
    showPromptModal.value = true
  }

  /**
   * Closes the prompt modal
   */
  const closePromptModal = () => {
    showPromptModal.value = false
    selectedCategory.value = null
  }

  /**
   * Selects a category for prompt management
   * @param {Object} category - The category to select
   */
  const selectCategory = (category) => {
    selectedCategory.value = category
  }

  return {
    // State
    showPromptModal,
    selectedCategory,
    isLoading,
    
    // Methods
    openPromptModal,
    closePromptModal,
    selectCategory,
  }
}
